<h6 class="m-0 block whitespace-nowrap px-4 py-2 text-sm text-neutral-400">
  <ng-content></ng-content>
</h6>
